import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from '@mui/material'
import { ChangeEvent, FC, useState } from 'react'
import LoadingButton from '@mui/lab/LoadingButton'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { cancelRide } from '../../../services/create-ride/api'
import { stringifyError } from '../../../utils/utils-functions'
import { enqueueSnackbar } from 'notistack'

export type ICancelRideProps = {
  onClose: (value: boolean) => void;
  open: boolean;
  ridesId: number | null;
}

const REASONS: string[] = [
  'Canceled by MTA',
  'No vehicle available'
]

const CancelRideDialog: FC<ICancelRideProps> = ({ onClose, open, ridesId }) => {
  const queryClient = useQueryClient()
  const [reason, setReason] = useState(REASONS[0])

  const { mutateAsync: cancelRideRequest, isLoading: cancelRideLoading } = useMutation(cancelRide)

  const handlerClose = () => {
    onClose(false)
  }

  const handlerSubmit = async () => {
    try {
      if (!ridesId) return
      await cancelRideRequest({ id: ridesId, reason })
      enqueueSnackbar(`Ride ${ridesId} canceled`, { variant: 'success' })
      onClose(false)
      queryClient.refetchQueries({
        queryKey: ['ride']
      })
    } catch (e) {
      console.error(e)
      enqueueSnackbar(stringifyError(e), { variant: 'error' })
    }
  }

  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      open={open}
      onClose={handlerClose}
    >
      <DialogTitle>
        Cancel Ride
      </DialogTitle>
      <DialogContent>
        <TextField
          select
          fullWidth
          margin="normal"
          label="Reason"
          value={reason}
          onChange={(e :ChangeEvent<HTMLInputElement>) => setReason(e.target.value)}
        >
          {REASONS.map(option => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handlerClose}>Disagree</Button>
        <LoadingButton
          autoFocus
          loading={cancelRideLoading}
          onClick={handlerSubmit}
          variant="contained"
        >
          Agree
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default CancelRideDialog
